import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    Subscription,
    SubscriptionStatus
} from '../types';
import {
    useNavigate,
    useParams
} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<Subscription, 'id'>,
    handleSubmit: (values: Subscription) => void
}) => {

    const {id: customerId} = useParams();

    const navigate = useNavigate()

    const onSubmit = (values: Subscription) => {

        values.items = values.items.map((item: { priceId: string, quantity: number }) => {
            return {
                priceId: item.priceId,
                quantity: Number(item.quantity)
            }
        });
        console.debug(values)

        handleSubmit(values);
        navigate(`/customers/${customerId}`);
    };

    const onCancel = () => {
        console.debug('onCancel', customerId);
        navigate(`/customers/${customerId}`);
    };


    let initialValues = {
        customerId: customerId,
        items: [],
        status: SubscriptionStatus.Active
    } as any as Subscription;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={true && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
